import { Component, OnDestroy, OnInit } from '@angular/core'
import { FuseTranslationLoaderService } from '../../../../core/services/translation-loader.service'
import { OriginDialogComponent } from './dialogs/compose/compose.component'
import { MatDialog } from '@angular/material'
import { Subscription } from 'rxjs/Subscription'
import { locale } from './i18n/nl'
import { FormControl } from '@angular/forms'
import { OriginService } from './origin.service'
import { OriginModel } from './models/origin.model'
import { FormGroup } from '@angular/forms'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/do'

@Component({
  selector: 'app-origins',
  templateUrl: './origins.component.html',
  styleUrls: ['./origins.component.scss'],
})
export class OriginsComponent implements OnInit, OnDestroy {
  searchInput: FormControl
  currentOrigin: OriginModel
  onOriginChanged: Subscription
  onSearchChanged: Subscription
  onOriginsChange: Subscription
  dialogRef: any
  totalOrigins = 0

  constructor(
    private originService: OriginService,
    private translationLoader: FuseTranslationLoaderService,
    public dialog: MatDialog,
  ) {
    this.translationLoader.loadTranslations(locale)
    this.searchInput = new FormControl('')
  }

  ngOnInit() {
    this.onOriginChanged = this.originService.onOriginChanged.subscribe(origin => {
      this.currentOrigin = origin
    })

    this.onSearchChanged = this.searchInput.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .do(searchText => this.originService.changeSearch(searchText))
      .subscribe(searchText => {
        this.currentOrigin = undefined
      })

    this.onOriginsChange = this.originService.onOriginsChange.subscribe(data => {
      if (data != undefined) {
        this.totalOrigins = data.pagination.total_results
      }
    })
  }

  createDialog() {
    this.dialogRef = this.dialog.open(OriginDialogComponent, {
      panelClass: 'mail-compose-dialog',
    })
    this.dialogRef.afterClosed().subscribe(response => {
      if (!response) {
        return
      }
      const formData: FormGroup = response

      const origin = new OriginModel()
      origin.name = formData.get('name').value
      origin.description = formData.get('description').value

      this.originService
        .add(origin)
        .do(() => this.originService.changeSearch(''))
        .subscribe()
    })
  }

  ngOnDestroy() {
    this.onOriginChanged.unsubscribe()
    this.onSearchChanged.unsubscribe()
    this.onOriginsChange.unsubscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/system/origins/origins.component.ts